import { Tooltip } from '@mui/material';
import { FontDownloadOutlined, WarningAmberOutlined } from '@mui/icons-material';
import type { VmFontPackPoolInfoDto } from '@/types/dtos/vm/vm-font-pack.dto';
import { formatVmFontPackTooltip } from '@/helpers/vm-font-pack.helper';

export function VmFontPackIndicator({ fontPack }: { fontPack?: VmFontPackPoolInfoDto }) {
  if (!fontPack) {
    return null;
  }

  const tooltip = formatVmFontPackTooltip(fontPack);
  const showWarning = !fontPack.known || !fontPack.upToDate;

  return (
    <Tooltip title={tooltip}>
      {showWarning ? (
        <WarningAmberOutlined sx={{ fontSize: 14, color: 'warning.main', verticalAlign: 'middle' }} />
      ) : (
        <FontDownloadOutlined sx={{ fontSize: 14, color: 'text.secondary', verticalAlign: 'middle' }} />
      )}
    </Tooltip>
  );
}
